import React, {useEffect, useRef, useState} from "react"
import PropTypes from "prop-types"
import {Badge, Button, Card, CardBody, Col, Container, Form, FormGroup, Label, Row} from "reactstrap"
import {connect} from "react-redux"
import { useLocation, withRouter } from "react-router-dom"

import {registerLocale, setDefaultLocale} from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"
import ptBR from "date-fns/locale/pt-BR"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
    editarGrupoEstoque,
    navegarEditarGrupoEstoque, navegarListarEstoque, relatorioExecutar,
    removerGrupoEstoque
} from "../../store/auth/profile/actions"
import usePermission from "helpers/permission/usePermission"
import AlertaSemVinculo from "../../components/Common/alerta-sem-vinculo"

registerLocale("ptBR", ptBR)
setDefaultLocale("ptBR")

import {ptBR as ptBRDatePickers} from '@mui/x-date-pickers'
import {getCompanies, getCompaniesValuesByOptions, getCompanyOption} from "../../helpers/utils"
import FormFilterCompany from "../../components/Common/form-filter-company"
import GrupoEstoqueTable from "./grupo-estoque-table"
import FormFilterSelect from "../../components/Common/form-filter-select"
import { navegarBreadCrumb } from "../../store/navigator/actions"

const GrupoEstoqueLista = props => {

    const ref = useRef();

    const [filters, setFilters] = useState(null)

    const [companies, setCompanies] = useState([])
    const [companiesOption, setCompaniesOption] = useState([])
    const [subgrupo, setSubgrupo] = useState()

    const usePermissionRemove = usePermission("gruposEstoque_excluir")
    const usePermissionInsert = usePermission("gruposEstoque_inserir")
    const usePermissionEdit = usePermission("gruposEstoque_editar")
    const estoquePermissionList = usePermission("estoques_listar")

    const possuiVinculo = (props.user?.vinculos || []).some(vinculo => ["A", "T"].includes(vinculo.vinculo_status))
    const location = useLocation();

    useEffect(() => {
        if(props.dashboardFilters.companiesSelected) setCompanies(props.dashboardFilters.companiesSelected)

        if (possuiVinculo) {
            populateFiltros(props.dashboardFilters.companiesSelected)
        }
        props.navegarBreadCrumb({title: `breadcrumb.stock.group.title`, link: location.pathname})
    }, [])

    useEffect(() => {
        if(props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador && Array.isArray(props.empresas)) {
            let companiesOptions = props.empresas.map(empresa => getCompanyOption(empresa));
            setCompaniesOption(companiesOptions)
        } else {
            let companiesOptions = getCompanies(props.user)
            setCompaniesOption(companiesOptions)
        }
        return () => {
            setCompaniesOption([])
        }
    }, [props.user, props.empresas])

    useEffect(() => {
        if(props.grupoEstoqueRemovido) {
            pesquisar()
        }
    }, [props.grupoEstoqueRemovido])

    const populateFiltros = (companiesSelected) => {
        const filters = []

        if(companiesSelected) {
            filters.push({id: 'idEmpresa', value: getCompaniesValuesByOptions(companiesSelected)})
        } else if(companies) {
            filters.push({id: 'idEmpresa', value: getCompaniesValuesByOptions(companies)})
        }

        if (subgrupo) filters.push({ id: 'subgrupo', value: subgrupo })

        setFilters(filters)
    }

    const pesquisar = () => {
        populateFiltros()
        setTimeout(() => ref?.current?.search(), 300)
    }

    const goToGrupo = item => {
        props.navegarEditarGrupoEstoque(item)

        let state
        if (!item && Array.isArray(companies) && companies.length === 1 && companies[0]?.value) {
            state = { empresaPreSelecionada: companies[0].value }
        }

        props.history.push("/grupo-estoque"+(item?`/${item.id}`: ""), state)
    }

    const goToEstoque = item => {
        props.history.push("/estoques")
        props.navegarListarEstoque({ grupo: item, company: getCompaniesValuesByOptions(companies) })
    }

    const printPDF = () => {
        let reportName = 'grupo_estoque';
        props.relatorioExecutar({
            company: getCompaniesValuesByOptions(companies),
            subgrupo: subgrupo,
            reportName
        });
    }

    if (
        !props.user ||
        !props.user.vinculos.length ||
        !(props.user.vinculos || []).filter(e =>
            ["A", "T"].find(status => status == e.vinculo_status)
        ).length
    ) {
        return (
            <AlertaSemVinculo/>
        )
    }

    const companiesValidas = companiesOption.filter(c => c.value)
    const multiplasEmpresas = companiesValidas.length > 1
    const empresaUnicaDisponivel = companiesValidas.length === 1 ? companiesValidas[0] : null
    const empresaUnicaSelecionada = (Array.isArray(companies) && companies.length === 1 && companies[0]?.value) ? companies[0] : null

    const renderContextoEmpresa = () => {
        if (!multiplasEmpresas) return null
        if (empresaUnicaSelecionada) {
            return <>Empresa em contexto: <strong className="text-dark">{ empresaUnicaSelecionada.label }</strong></>
        }
        return <>Empresas em contexto: <strong className="text-dark">múltiplas empresas</strong></>
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs title="breadcrumb.stock.group.title"/>

                    <Row>
                        <Col lg="12">
                            <div>
                                <Card>
                                    <CardBody>
                                        <h4 className="card-title mb-3">Grupos de estoque</h4>

                                        { renderContextoEmpresa() && (
                                            <div className="d-flex align-items-center mb-3">
                                                <i className="bx bx-buildings font-size-18 text-primary me-2" />
                                                <span className="text-muted">{ renderContextoEmpresa() }</span>
                                            </div>
                                        ) }

                                        <Form>
                                            <Row>
                                                { multiplasEmpresas ? (
                                                    <div className="col-md-3 col-sm-12">
                                                        <FormFilterCompany
                                                            attribute="companies"
                                                            value={companies}
                                                            description="Empresa(s)"
                                                            setValue={ value => setCompanies(value) }
                                                            options={companiesOption}
                                                            multiple={ true }
                                                            hasSelectAll={ !(props.user?.usuario_info && props.user?.usuario_info?.perfil?.administrador) }
                                                        />
                                                    </div>
                                                ) : empresaUnicaDisponivel && (
                                                    <div className="col-md-3 col-sm-12">
                                                        <FormGroup className="mt-3 mb-0">
                                                            <Label>Empresa</Label>
                                                            <div className="form-control-plaintext fw-bold text-dark">
                                                                <i className="bx bx-buildings text-primary me-2" />
                                                                { empresaUnicaDisponivel.label }
                                                            </div>
                                                        </FormGroup>
                                                    </div>
                                                ) }

                                                <div className="col-md-2 col-sm-12">
                                                    <FormFilterSelect
                                                        attribute="subgrupo"
                                                        value={subgrupo}
                                                        description="Tipo do grupo"
                                                        changeHandeler={ value => setSubgrupo(value) }
                                                        options={ [
                                                            { value: ""  , label: "Todos", defaultValue: true },
                                                            { value: "N", label: "Grupo" },
                                                            { value: "S", label: "Subgrupo" },
                                                        ] }
                                                    />
                                                </div>

                                                <div className="col col-auto align-self-start mt-md-4 pt-1 row">
                                                    <div className="mt-3 col col-auto">
                                                        <Button color="primary" className="w-md" onClick={e => pesquisar()}>
                                                            Buscar
                                                        </Button>
                                                    </div>

                                                    <div className="mt-3 col col-auto">
                                                        <Button
                                                            type="button"
                                                            color="success"
                                                            disabled={ !(usePermissionEdit || usePermissionInsert) }
                                                            onClick={ e => goToGrupo(null) }>
                                                            <i className="bx bx-plus" /> Cadastrar
                                                        </Button>
                                                    </div>

                                                    { !props.executaRelatorioLoading &&
                                                        <div className="mt-3 col col-auto">
                                                            <Button type="button" color="light" onClick={ e => printPDF() }>
                                                                <i className="bx bx-download align-middle font-size-16 me-2"></i>
                                                                PDF
                                                            </Button>
                                                        </div>
                                                    }
                                                </div>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Card>

                                { filters && <Card>
                                    <CardBody>
                                        <GrupoEstoqueTable ref={ref} filters={filters}
                                                     history={props.history}
                                                     usePermissionRemove={ usePermissionRemove }
                                                     usePermissionEdit={ usePermissionEdit }
                                                     navegarListarEstoque={ estoquePermissionList ? goToEstoque : null }
                                                     navegarEditarGrupoEstoque={ goToGrupo }
                                                     removerGrupoEstoque={ (data) => props.removerGrupoEstoque({ id : data.id }, props.history)}>
                                        </GrupoEstoqueTable>
                                    </CardBody>
                                </Card> }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

GrupoEstoqueLista.propTypes = {
    grupoEstoqueRemovido: PropTypes.any,
    removerGrupoEstoque: PropTypes.func,
    editarGrupoEstoque: PropTypes.func,
    relatorioExecutar: PropTypes.func,
    navegarEditarGrupoEstoque: PropTypes.func,
    navegarListarEstoque: PropTypes.func,
}

const mapStatetoProps = state => {
    const { grupoEstoqueRemovido, empresas, empresasLoading } = state.Profile
    const { user, dashboardFilters } = state.Login
    return { user, grupoEstoqueRemovido, dashboardFilters, empresas, empresasLoading }
}

export default connect(mapStatetoProps, {
    navegarEditarGrupoEstoque,
    navegarListarEstoque,
    removerGrupoEstoque,
    editarGrupoEstoque,
    relatorioExecutar,
    navegarBreadCrumb
})(withRouter(GrupoEstoqueLista))
